module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/countries-1271da85270ff255452326b9e5a978c6.png";